// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Site status gate (Maintenance / Down) */
.site-status-page {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #fdfaf1;
  overflow: auto;
}

.site-status-page__atmosphere {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 60% at 20% 10%, rgba(250, 226, 207, 0.95) 0%, transparent 55%),
    radial-gradient(ellipse 70% 50% at 85% 80%, rgba(201, 51, 18, 0.08) 0%, transparent 50%),
    linear-gradient(160deg, #fdfaf1 0%, #fae2cf 45%, #f5d4b8 100%);
  pointer-events: none;
}

.site-status-page__panel {
  position: relative;
  z-index: 1;
  width: min(560px, 100%);
  text-align: center;
  padding: clamp(2rem, 5vw, 3.25rem) clamp(1.5rem, 4vw, 2.5rem);
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 24px;
  box-shadow: 0 18px 48px rgba(46, 46, 46, 0.08);
  backdrop-filter: blur(8px);
}

.site-status-page__logo {
  display: block;
  height: 48px;
  width: auto;
  margin: 0 auto 1.5rem;
}

.site-status-page__eyebrow {
  margin: 0 0 0.75rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #c93312;
}

.site-status-page__title {
  margin: 0 0 1rem;
  font-family: "Helvetica Bold", Helvetica, Arial, sans-serif;
  font-size: clamp(1.75rem, 4vw, 2.75rem);
  font-weight: 800;
  line-height: 1.15;
  color: #111;
}

.site-status-page__description {
  margin: 0 0 0.75rem;
  font-size: 1.05rem;
  line-height: 1.55;
  color: #333;
}

.site-status-page__hint {
  margin: 0 0 1.75rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #666;
}

.site-status-page__contact {
  display: inline-block;
  padding: 10px 28px;
  background-color: #c93312;
  color: #fff !important;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.site-status-page__contact:hover,
.site-status-page__contact:focus {
  background-color: #a8290e;
  color: #fff !important;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/web-pages/SiteStatusPage.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;kEAGgE;EAChE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,6DAA6D;EAC7D,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2DAA2D;EAC3D,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":["/* Site status gate (Maintenance / Down) */\n.site-status-page {\n  position: fixed;\n  inset: 0;\n  z-index: 20000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: #fdfaf1;\n  overflow: auto;\n}\n\n.site-status-page__atmosphere {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(ellipse 80% 60% at 20% 10%, rgba(250, 226, 207, 0.95) 0%, transparent 55%),\n    radial-gradient(ellipse 70% 50% at 85% 80%, rgba(201, 51, 18, 0.08) 0%, transparent 50%),\n    linear-gradient(160deg, #fdfaf1 0%, #fae2cf 45%, #f5d4b8 100%);\n  pointer-events: none;\n}\n\n.site-status-page__panel {\n  position: relative;\n  z-index: 1;\n  width: min(560px, 100%);\n  text-align: center;\n  padding: clamp(2rem, 5vw, 3.25rem) clamp(1.5rem, 4vw, 2.5rem);\n  background: rgba(255, 255, 255, 0.72);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 24px;\n  box-shadow: 0 18px 48px rgba(46, 46, 46, 0.08);\n  backdrop-filter: blur(8px);\n}\n\n.site-status-page__logo {\n  display: block;\n  height: 48px;\n  width: auto;\n  margin: 0 auto 1.5rem;\n}\n\n.site-status-page__eyebrow {\n  margin: 0 0 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #c93312;\n}\n\n.site-status-page__title {\n  margin: 0 0 1rem;\n  font-family: \"Helvetica Bold\", Helvetica, Arial, sans-serif;\n  font-size: clamp(1.75rem, 4vw, 2.75rem);\n  font-weight: 800;\n  line-height: 1.15;\n  color: #111;\n}\n\n.site-status-page__description {\n  margin: 0 0 0.75rem;\n  font-size: 1.05rem;\n  line-height: 1.55;\n  color: #333;\n}\n\n.site-status-page__hint {\n  margin: 0 0 1.75rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #666;\n}\n\n.site-status-page__contact {\n  display: inline-block;\n  padding: 10px 28px;\n  background-color: #c93312;\n  color: #fff !important;\n  font-weight: 600;\n  font-size: 0.95rem;\n  text-decoration: none;\n  border-radius: 8px;\n  transition: background-color 0.15s ease, transform 0.15s ease;\n}\n\n.site-status-page__contact:hover,\n.site-status-page__contact:focus {\n  background-color: #a8290e;\n  color: #fff !important;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
